export default __webpack_public_path__ + "static/diamond-1-f04b5257d4a65e4bee0efb8ae43e2f74.png";